export const CGU_VERSION = "1.1"